<template>
  <b-nav-item-dropdown
      class="dropdown-notification mr-25"
      menu-class="dropdown-menu-media"
      right
  >
    <template #button-content>
      <feather-icon
          :badge="$store.state.task.tasks.length"
          badge-classes="bg-danger"
          class="text-body"
          icon="CheckSquareIcon"
          size="21"
      />
    </template>

    <!-- Header -->
    <li class="dropdown-menu-header">
      <div class="dropdown-header d-flex">
        <h4 class="notification-title mb-0 mr-auto">
          وظایف جدید
        </h4>
        <b-badge
            pill
            variant="light-primary"
            v-show="$store.state.task.tasks.length"
        >
          {{ $store.state.task.tasks.length }} جدید
        </b-badge>
      </div>
    </li>

    <!-- Notifications -->
    <vue-perfect-scrollbar
        :settings="perfectScrollbarSettings"
        class="scrollable-container media-list scroll-area"
        tagname="li"
    >
      <b-link
          v-for="task in $store.state.task.tasks"
          :key="task.id"
          :to="{path:'/tasks/inbox'}"
      >
        <b-media>
          <p class="media-heading">
            <span class="font-weight-bolder">
              {{ task.title }}
            </span>
          </p>
          <small class="notification-text">{{ task.content }}</small>
        </b-media>
      </b-link>

    </vue-perfect-scrollbar>

    <!-- Cart Footer -->
    <li class="dropdown-menu-footer">
      <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="primary"
          block
          @click="$router.push({path: '/tasks/inbox'})"
      >مشاهده تمام تسک ها
      </b-button>
    </li>
  </b-nav-item-dropdown>
</template>

<script>
import {
  BNavItemDropdown, BBadge, BMedia, BLink, BAvatar, BButton, BFormCheckbox,
} from 'bootstrap-vue'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import Ripple from 'vue-ripple-directive'
import store from "@/store";
import {getUserData} from "@/auth/utils";

export default {
  name: "TaskNavBar",
  components: {
    BNavItemDropdown,
    BBadge,
    BMedia,
    BLink,
    BAvatar,
    VuePerfectScrollbar,
    BButton,
    BFormCheckbox,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      tasks: [],
      perfectScrollbarSettings: {
        maxScrollbarLength: 60,
        wheelPropagation: false,
      }
    }
  },
  methods: {
    getTasks() {
      this.$http.get(`tasks/inbox`)
          .then(({data}) => {
            if (data.status) {
              store.commit('task/ADD_TASKS_TO_LIST', data.tasks)
            }
          })
    },
    async listen() {
      const router = this.$router
      setTimeout(() => {
        this.$echo
            .channel(`task.${this.$store.state.user.data.id}`)
            .listen('.NewTaskEvent', (task) => {
              const tasks = store.state.task.tasks
              tasks.unshift(task)
              store.commit('task/ADD_TASKS_TO_LIST', tasks)
              this.$bvToast.toast(task.title, {
                title: 'وظیفه جدید',
                variant: 'info',
                toaster: 'b-toaster-top-left'
              })

              this.$notification.show('وظیفه جدید', {
                body: task.title
              }, {
                onclick: function () {
                  router.push({ name: 'Todo',params:{'pageType':data.id} })
                }
              })
            })
            .listen('.UpdateTaskEvent', (updatedTask) => {
              let tasks = store.state.task.tasks
              if (tasks.some((task, index) => {
                if (task.id === updatedTask.id) {
                  tasks.splice(index, 1)
                  tasks.unshift(updatedTask)
                  return true
                }
                return false
              }))

                store.commit('task/ADD_TASKS_TO_LIST', tasks)
              this.$bvToast.toast(updatedTask.title, {
                title: 'به روزرسانی وظیفه',
                variant: 'primary',
                toaster: 'b-toaster-top-left'
              })
              this.$notification.show('بروزرسانی وظیفه', {
                body: updatedTask.title
              }, {
                onclick: function () {
                  router.push({ name: 'Todo',params:{'pageType':data.id} })
                }
              })
              // tasks = tasks.map((task) =>{
              //   if (task.id === )
              // })

            })
        ;

      }, 3000)
    }
  },
  mounted() {
    this.getTasks()
    this.listen()
  }
}
</script>

<style>

</style>
